<script setup lang="ts">
import useI18nStore from '@/store/i18nStore'
import MicroDialog from '@/components/micro-dialog'

const i18nStore = useI18nStore()

const changeLanguage = () => {
  i18nStore.setLanguage(i18nStore.language)
}

function open() {
  console.log('MicroDialog.op', MicroDialog({ message: '11' }))
}
</script>

<template>
  <div>
    {{ $t('change locale') }}
    <select v-model="i18nStore.language" @change="changeLanguage()">
      <option v-for="language in i18nStore.languages" :value="language" :label="$t(language)" :key="language"></option>
    </select>
    <p>{{ $t('current locale') }}：{{ i18nStore.language }}</p>
  </div>
  {{ $t('hello') }},
  {{ $t('welcome to') }}
  {{ $t('demo display') }}
  <div @click="open">open</div>
</template>

<style lang="scss" scoped>
.login {
  .success {
    color: darkgreen;
  }
}
select {
  background-color: #eee;
  border-style: solid;
  margin-left: 10px;
}
</style>
